module.exports = __webpack_public_path__ + "img/Honig-aus-2021-1220.a1825c3a.jpg";